import React from 'react';
import aggregationFilterHelper from '../../../infrastructure/helpers/functions/aggregation/aggregationFilterHelper';
import StatementHelper from '../../../infrastructure/types/Functions/StatementHelper';
import AggregationFilter from '../../../types/report/AggregationFilter';
import StatementBlockBuilder from '../../Functions/Statement/StatementBlockBuilder';
import StatementBlockBuilderProps from '../../Functions/Statement/StatementBlockBuilderProps';
import AggregationFilterBuilder from './AggregationFilterBuilder';

interface RemoveProps {
    statements?: AggregationFilter[],
    statementHelper?: StatementHelper<AggregationFilter>
}

class AggregationFilterBlockBuilder extends React.Component<Omit<StatementBlockBuilderProps<AggregationFilter>, keyof RemoveProps>> {

    render(): JSX.Element {

        const allFilters = this.props.reportConfig.aggregations
            .map(x => x.filters)
            .flat()
            .sort((a, b) => a.number - b.number);

        if (allFilters.length === 0) { 
            return <></>;
        }

        return (
            <StatementBlockBuilder
                childComponentType={AggregationFilterBuilder}
                isWaiting={this.props.isWaiting}
                isReadOnly={this.props.isReadOnly}
                caseNumber={null}
                reportConfig={this.props.reportConfig}
                counts={this.props.counts}
                statements={allFilters}
                collections={this.props.collections}
                clipboard={this.props.clipboard}
                onChange={this.props.onChange}
                onClipboardChange={this.props.onClipboardChange}
                getOperandRuleBundle={this.props.getOperandRuleBundle}
                validateRemoveStatement={this.props.validateRemoveStatement}
                onConditionUpdate={this.props.onConditionUpdate}
                statementHelper={aggregationFilterHelper}
                details={this.props.details} />
        );
    }
}

export default AggregationFilterBlockBuilder;
